import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { hospitalsActions } from '../../../actions/hospitalsActions';
import RequieredInputs from '../../common/RequiredInputs';
import './HospitalSelect.scss';

const HospitalSelect = ({
    hospitals = [],
    inputs = {},
    value = '',
    handleChange = () => {},
    name = 'id_Hospitales',
}) => {
    const _label = "Hospital / Centro";
    const [search, setSearch] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);

    // Filtra hospitales según el texto de búsqueda
    const filteredHospitals = hospitals.filter(hospital =>
        hospital.nombre.toLowerCase().includes(search.toLowerCase())
    );

    // Maneja selección de hospital
    const handleSelect = (id_Hospital, nombre) => {
        handleChange({
            target: {
                name,
                value: id_Hospital,
            },
        });
        setSearch(nombre);
        setShowDropdown(false);
    };

    // Actualiza el input y muestra el dropdown
    const handleInputChange = (e) => {
        setSearch(e.target.value);
        setShowDropdown(true);
        handleChange({
            target: {
                name,
                value: '',
            },
        });
    };

    // Cierra el dropdown si se hace click fuera
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.hospital-select-dropdown')) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (inputs.id_Hospitales) {
            const selectedHospital = hospitals.find(h => h.id_Hospital === inputs.id_Hospitales);
            if (selectedHospital) {
                setSearch(selectedHospital.nombre);
            }
        }
    }, [inputs.id_Hospitales])

    return (
        <Form.Group size='lg' className='hospital-select-dropdown' style={{ position: 'relative' }}>
            <Form.Label className='form__labels'>
                {_label}
                <RequieredInputs />
            </Form.Label>
            <Form.Control
                as="input"
                type='text'
                className='user-input form__input'
                placeholder='Buscar hospital...'
                value={search}
                // value={inputs?.id_Hospitales || inputs?.id_Hospitales || ''}
                onChange={handleInputChange}
                onClick={() => setShowDropdown(true)}
                autoComplete='off'
                name={`${name}_search`}
            />
            <div className="hospital-select-rightSection">
                {search && (
                    <button
                        className="remove-button"
                        type="button"
                        aria-label="Limpiar selección"
                        onClick={() => {
                            setSearch('');
                            setShowDropdown(false);
                            handleChange({
                                target: {
                                    name,
                                    value: '',
                                },
                            });
                        }}
                    >
                        &#10005;
                    </button>
                )}
                {/* Dropdown icon */}
                <button className="dropdown-button" type="button" aria-label="Toggle dropdown" onClick={() => setShowDropdown(!showDropdown)}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                        <polyline
                            points="8 10 12 14 16 10"
                            stroke="#ff9800"
                            strokeWidth="1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </div>

            {showDropdown && (
                <div
                    className='hospital-select-dropdown'
                >
                    {filteredHospitals.map((hospital) => (
                            <div
                                key={hospital.id_Hospital}
                                onClick={() => handleSelect(hospital.id_Hospital, hospital.nombre)}
                            >
                                {hospital.nombre}
                            </div>
                        ))
                    }
                </div>
            )}
        </Form.Group>
    );
};

export default HospitalSelect;
